@use "styles/project-theme" as *;

.root {
  overflow: auto;
  position: relative;
  height: 100%;
  width: 100%;
  &::-webkit-scrollbar {
    width: 0.6rem;
    height: 0.6rem;
    background-color: transparent;
    border-radius: 0.6rem;
    cursor: pointer;
  }

  &::-webkit-scrollbar-track {
    border-radius: 0.4rem;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0.7rem;
    background-color: transparent;
  }
}
.visible {
  &::-webkit-scrollbar {
    background-color: rgba(gray, 0.2);
  }
  &::-webkit-scrollbar-track {
    background-color: rgba($color-table, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background-color: $color_primary_text;
    &:hover {
      background-color: $color_primary_text;
    }
  }
}
.hover {
  &:hover {
    &::-webkit-scrollbar {
      background-color: rgba(gray, 0.2);
    }
    &::-webkit-scrollbar-track {
      background-color: rgba($color-table, 0.1);
    }
    &::-webkit-scrollbar-thumb {
      background-color: $color_primary_text;
      &:hover {
        background-color: $color_primary_text;
      }
    }
  }
}
